import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('bringozDurationFormatted', bringozDurationFormatted);

function bringozDurationFormatted(moment) {
  return function bringozDurationFormattedFilter(duration) {

    const negative = duration < 0;
    if (negative) {
      duration = duration * -1;
    }

    const dur = moment.duration(duration);
    const hours = Math.floor(dur.asHours());
    const mins = Math.floor(dur.asMinutes()) - hours * 60;
    const sec = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60;

    const formatted = hours + ':' + ((mins > 9) ? mins : ('0' + mins)) + ':' + ((sec > 9) ? sec : ('0' + sec));
    return negative ? '-' + formatted : formatted;
  }
}
